import Alpine from "alpinejs";

window.Alpine = Alpine;
Alpine.start();

// Styles
///////////////////////////////
import "../styles/global.css";

// Scripts
/////////////////////////////////

// Components
import "@/components/navigation/navigation.js";
import "@/components/navigation/menu.js";
import "@/components/forms/inputs/input-phone.js";
import "@/components/forms/inputs/select.js";
import "@/components/forms/inputs/multi-select.js";
import "@/components/tooltip.js";

// Modules
import "@/modules/smooth-scroll.js";
import "@/modules/video.js";

// Utils
import "@/utils/input-validator.js";
import "@/utils/form-validator.js";
import "@/utils/form-send.js";
import "@/utils/alert.js";
import "@/utils/modal.js";
import "@/utils/translator.js";
import "@/utils/conversion.js";
